// includes a react-redux-form
import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Label, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, Form, Errors, actions } from 'react-redux-form';

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len); 
const minLength = (len) => (val) => val && (val.length >= len);
const isNumber = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);
class Contact extends Component {

        // Will invoke when the component is created
        constructor(props) {
            super(props);  // supply the props to the super class
    
            this.handleSubmit = this.handleSubmit.bind(this);
        }
    
        handleSubmit(values) {
            console.log("Current State is: " + JSON.stringify(values));
            alert("Current State is: " + JSON.stringify(values));
            this.props.resetFeedbackForm();
            // event.preventDefault();
        }

    // constructor(props) {
    //     super(props);

    //     this.state = {
    //         firstname: '',
    //         lastname: '',
    //         telnum: '',
    //         email: '',
    //         agree: false,
    //         contactType: 'Tel.',
    //         message: '',
    //         touched: {
    //             firstname: false,
    //             lastname: false,
    //             telnum: false,
    //             email: false
    //         }
    //     };

    //     this.handleInputChange = this.handleInputChange.bind(this);
    //     this.handleSubmit = this.handleSubmit.bind(this);
    //     this.handleBlur = this.handleBlur.bind(this);
        
    // }

    // handleBlur = (field) => (evt) => {
    //     this.setState({
    //         touched: { ...this.state.touched, [field]: true }
    //     });
    // }

    // validate(firstname, lastname, telnum, email) {
    //     const errors = {
    //         firstname: '',
    //         lastname: '',
    //         telnum: '',
    //         email: ''
    //     };

    //     if (this.state.touched.firstname && firstname.length < 3)
    //         errors.firstname = 'First Name should be >= 3 characters';
    //     else if (this.state.touched.firstname && firstname.length > 10)
    //         errors.firstname = 'First Name should be <= 10 characters';

    //     if (this.state.touched.lastname && lastname.length < 3)
    //         errors.lastname = 'Last Name should be >= 3 characters';
    //     else if (this.state.touched.lastname && lastname.length > 10)
    //         errors.lastname = 'Last Name should be <= 10 characters';

    //     const reg = /^\d+$/;
    //     if (this.state.touched.telnum && !reg.test(telnum))
    //         errors.telnum = 'Tel. Number should contain only numbers';

    //     if(this.state.touched.email && email.split('').filter(x => x === '@').length !== 1)
    //         errors.email = 'Email should contain a @';

    //     return errors;
    // }

    // handleInputChange (event) {
    //     const target = event.target
    //     const value = target.type === 'checkbox' ? target.checked : target.value
    //     const name = target.name 

    //     this.setState ({
    //         [name] : value
    //     })
    // }

    // handleSubmit (event) {
    //     console.log('submit clicked')
    //     alert('your feedback has been submitted')
    //     event.preventDefault() 
    // }

    render() {
        // const errors = this.validate(
        //     this.state.firstname,
        //     this.state.lastname,
        //     this.state.telnum,
        //     this.state.email
        // )
    
        return(
            <div className="container">
            <div className="row">
                <Breadcrumb>
                    <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Contact Us</BreadcrumbItem>
                </Breadcrumb>
                <div className="col-12">
                    <h3>Contact Us</h3>
                    <hr />
                </div>
            </div>
            <div className="row row-content">
                <div className="col-12">
                <h3>Location Information</h3>
                </div>
                <div className="col-12 col-sm-4 offset-sm-1">
                        <h5>Our Address</h5>
                        <address>
                        189, Yalanghoch Array<br />
                        Mirza Ulughbek District<br />
                        Tashkent, UZBEKISTAN<br />
                        <i className="fa fa-phone"></i>&nbsp;&nbsp;&nbsp;&nbsp;+998 71 1234 5678<br />
                        <i className="fa fa-fax"></i>&nbsp;&nbsp;&nbsp;&nbsp;+998 71 1234 5677<br />
                        <i className="fa fa-envelope"></i>&nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:info@mirzaevmuzaffar.com">info@mirzaevmuzaffar.com</a>
                        </address>
                        <br/>
                        <div className="col-12 col-sm-11">
                        <div className="btn-group" role="group">
                            <a role="button" className="btn btn-primary" href="tel:+9987112345678"><i className="fa fa-phone"></i> Call</a>
                            <a role="button" className="btn btn-info" href="https://www.skype.com/en/"><i className="fa fa-skype"></i> Skype</a>
                            <a role="button" className="btn btn-success" href="info@mirzaevmuzaffar.com"><i className="fa fa-envelope-o"></i> Email</a>
                        </div>
                    </div>
                </div>
                
                <div className="col-12 col-sm-6 offset-sm-1">
                    <h5>Map of our Location</h5>
                    <iframe width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.4184274021654!2d65.95814651565891!3d40.03277477941162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f52073ba97db321%3A0xee9cf96b02d0f54b!2s%22SADAF%20AL&#39;O%20SIFAT%22%20STOMATOLOGIYA!5e1!3m2!1sen!2skr!4v1615413150090!5m2!1sen!2skr"></iframe>
                </div>

            </div>
            <div className="row row-content">
                <div className="col-12">
                    <h3>Send us your feedback</h3>
                    <br/>
                </div>
                <div className="col-12 col-md-9">
                    <Form model="feedback" onSubmit={(values) => this.handleSubmit(values)}>
                        <Row className="form-group">
                            <Label htmlFor="firstname" md={2}>First Name</Label>
                            <Col md={10}>
                                <Control.text model=".firstname" id="firstname" 
                                        className="form-control"
                                        name="firstname" placeholder="First Name"
                                        validators={{
                                            required, 
                                            minLength: minLength(3),
                                            maxLength: maxLength(15)
                                        }} />
                                <Errors className="text-danger" model=".firstname"
                                        show="touched"
                                        messages={{
                                            required: 'Required ',
                                            minLength: 'Must be greater than 2 characters ',
                                            maxLength: 'Must be 15 characters or less'
                                        }}
                                    />
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <Label htmlFor="lastname" md={2}>Last Name</Label>
                            <Col md={10}>
                                <Control.text model=".lastname" id="lastname" 
                                        className="form-control"
                                        name="lastname" placeholder="Last Name"
                                        validators={{
                                            required, 
                                            minLength: minLength(3),
                                            maxLength: maxLength(15)
                                        }} />
                                <Errors className="text-danger" model=".lastname"
                                        show="touched"
                                        messages={{
                                            required: 'Required ',
                                            minLength: 'Must be greater than 2 characters ',
                                            maxLength: 'Must be 15 characters or less'
                                        }}
                                    />
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <Label htmlFor="telnum" md={2}>Contact Tel.</Label>
                            <Col md={10}>
                                <Control.text model=".telnum" id="telnum" 
                                        className="form-control"
                                        name="telnum" placeholder="Tel. Number"
                                        validators={{
                                            required, 
                                            minLength: minLength(3),
                                            maxLength: maxLength(15),
                                            isNumber
                                        }} />
                                <Errors className="text-danger" model=".telnum"
                                        show="touched"
                                        messages={{
                                            required: 'Required ',
                                            minLength: 'Must be greater than 2 numbers ',
                                            maxLength: 'Must be 15 numbers or less ',
                                            isNumber: 'Must be a number'
                                        }}
                                    />
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <Label htmlFor="email" md={2}>Email</Label>
                            <Col md={10}>
                                <Control.text model=".email" id="email" 
                                        className="form-control"
                                        name="email" placeholder="Email"
                                        validators={{
                                            required,
                                            validEmail
                                        }} />
                                <Errors className="text-danger" model=".email"
                                        show="touched"
                                        messages={{
                                            required: 'Required ',
                                            validEmail: 'Invalid Email Address '
                                        }}
                                    />
                            </Col>
                        </Row>
                        <Row className="form-group" style={{"align-items": "center"}}>
                            <Col md={{size: 6, offset: 2}}>
                                <div className="form-check">
                                    <Label check>
                                        <Control.checkbox model=".agree" name="agree" 
                                                className="form-check-input" /> {' '}
                                        <strong>May we contact you?</strong>
                                    </Label>
                                </div>
                            </Col>
                            <Col md={{size: 3, offset: 1}}>
                                <Control.select model=".contactType" name="contactType"
                                        className="form-control"
                                         >
                                    <option>Tel.</option>
                                    <option>Email</option>
                                </Control.select>
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <Label htmlFor="feedback" md={2}>Your Feedback</Label>
                            <Col md={10}>
                                <Control.textarea model=".message" id="message" 
                                        className="form-control"
                                        name="message" rows="12"
                                         />
                            </Col>
                        </Row>
                        <Row className="form-group">
                            <Col md={{size: 10, offset: 2}}>
                                <Button type="submit" color="primary">
                                    SEND FEEDBACK
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </div>
        );
        
    }
    
}

export default Contact;